import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import modules from "./modules";

Vue.use(Vuex);

var plugins = [];

if (process.env.NODE_ENV !== "production") {
  plugins = [createPersistedState({ storage: window.sessionStorage })];
}

const store = new Vuex.Store({
  modules,
  getters: {
    form: (state, getters) => {
      let form = {};
      Object.keys(state).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(state[key], "form")) {
          // Extract Arrays to individual properties
          for (var property in state[key].form) {
            if (
              state[key].form.hasOwnProperty(property) &&
              Array.isArray(state[key].form[property])
            ) {
              state[key].form[property].forEach(element => {
                form[property + "_" + element] = element;
              });
            }
          }

          form = Object.assign(form, state[key].form);
        }
        // Run formatters
        if (Object.prototype.hasOwnProperty.call(state[key], "formatters")) {
          for (const formatter of state[key].formatters) {
            Object.keys(formatter).forEach(formatterKey => {
              form[formatterKey] = getters[key + "/" + formatter[formatterKey]];
            });
          }
        }
      });

      return form;
    }
  },
  plugins: plugins,
  strict: process.env.NODE_ENV !== "production"
});

// Automatically run the `init` action for every module,
// if one exists.
for (const moduleName of Object.keys(modules)) {
  if (modules[moduleName].actions && modules[moduleName].actions.init) {
    store.dispatch(`${moduleName}/init`);
  }
}

export default store;
